<template>
  <div class="datetime-picker-overlay" v-if="isVisible">
    <div class="datetime-picker-modal">
      <div class="datetime-modal-header">
        <h2 class="title">Choose Date & Time</h2>
        <img src="/static/img/grey-x.svg" @click="$emit('close')" style="cursor: pointer;" />
      </div>

      <!-- Month, Day, Year Selection -->
      
      <div class="date-grid">
        <div>
            <div class="header-title">Month</div>
            <div class="month">
                <button
                    v-for="(month, index) in months"
                    :key="index"
                    :class="{ selected: selectedMonth === index }"
                    @click="selectMonth(index)"
                >
                    {{ month }}
                </button>
            </div>
        </div>
        
        <div>
            <div class="header-title">Day</div>
            <div class="day">
                <button
                    v-for="day in daysInMonth"
                    :key="day"
                    :class="{ selected: selectedDay === day }"
                    @click="selectDay(day)"
                >
                    {{ day }}
                </button>
            </div>
        </div>
        <div>
            <div class="header-title">Year</div>
            <div class="year">
                <button
                    v-for="year in years"
                    :key="year"
                    :class="{ selected: selectedYear === year }"
                    @click="selectYear(year)"
                >
                    {{ year }}
                </button>
            </div>
        </div>
      </div>

      <!-- Time Picker -->
      <div>
        <div class="header-title">Time</div>
        <div class="time-picker">
            <button
                v-for="time in times"
                :key="time"
                :class="{ selected: selectedTime === time }"
                @click="selectTime(time)"
            >
                {{ time }}
            </button>
        </div>
      </div>

      <button class="save-btn" @click="save">Save</button>
    </div>
  </div>
</template>

<script>
import dayjs from 'dayjs';

export default {
  props: ["isVisible"],
  data() {
    return {
      selectedMonth: new Date().getMonth(),
      selectedDay: new Date().getDate(),
      selectedYear: new Date().getFullYear(),
      selectedTime: "05:00",
      months: ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"],
      years: Array.from({ length: 4 }, (_, i) => new Date().getFullYear() + i),
      times: [ "05:00", "06:00", "07:00", "08:00", "09:00", "10:00", "11:00", "12:00", "13:00", "14:00", "15:00", "16:00", "17:00", "18:00", "19:00"],
    };
  },
  computed: {
    daysInMonth() {
      return new Date(this.selectedYear, this.selectedMonth + 1, 0).getDate();
    },
  },
  methods: {
    close() {
      this.$emit("close");
    },
    selectMonth(index) {
      this.selectedMonth = index;
    },
    selectDay(day) {
      this.selectedDay = day;
    },
    selectYear(year) {
      this.selectedYear = year;
    },
    selectTime(time) {
      this.selectedTime = time;
    },
    save() {
      this.$emit('getDate',
        dayjs(`${this.selectedYear}-${this.selectedMonth}-${this.selectedDay} ${this.selectedTime}`)
            .format("YYYY/MM/DD hh:mm A")
      );
      this.close();
    },
  },
};
</script>

<style scoped>
.datetime-picker-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  z-index: 999;
}
.datetime-picker-modal {
  background: #fff;
  padding: 0 20px 20px 20px;
  width: 530px;
  position: relative;
  border-radius: 10px;
}
.datetime-modal-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 10px;
}
.title {
  font-size: 20px;
  font-weight: bold;
  margin-bottom: 10px;
}
.close-btn {
  position: absolute;
  top: 10px;
  right: 10px;
  background: none;
  border: none;
  font-size: 20px;
  cursor: pointer;
}
.date-grid {
  display: grid;
  grid-template-columns: 2fr 4fr 1fr;
  gap: 15px;
  margin-bottom: 15px;
}
.month {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 5px;
}
.day {
    display: grid;
    grid-template-columns: repeat(8, 1fr);
    gap: 5px;
}
.year {
    display: grid;
    grid-template-columns: 1fr;
    gap: 5px;
}
.date-grid button,
.time-picker button {
  background: #fff;
  border: none;
  padding: 5px 3px;
  min-width: 30px;
  border-radius: 8px;
  cursor: pointer;
  font-size: 14px;
  color: rgba(0, 0, 0, 0.5);
  font-weight: normal;
}
.date-grid button.selected,
.time-picker button.selected {
  background: #3d82ff;
  color: #fff;
  font-weight: normal;
}
.time-picker {
  display: grid;
  grid-template-columns: repeat(8, 1fr);
  gap: 10px;
  margin-bottom: 15px;
}
.save-btn {
  background: #3d82ff;
  color: #fff;
  padding: 10px;
  border: none;
  width: 100%;
  font-size: 16px;
  cursor: pointer;
  border-radius: 10px;
}
.header-title {
    font-weight: bold;
    color: rgba(0, 0, 0, 0.5);
    margin-bottom: 15px;
    font-size: 14px;
}
</style>
